import "material-design-icons-iconfont/dist/material-design-icons.css";
// import './assets/icons/css/materialdesignicons.css'
import "./assets/fonts/style.css";
import "vue-toastification/dist/index.css";

import MomentUtils from "@hublot-io/core-utils/utils/MomentUtils";
import moment from "moment";
import { createPinia, PiniaVuePlugin, setActivePinia } from "pinia";
import { PiniaLogger } from "pinia-logger";
import Vue, { onMounted } from "vue";
import VueKeyCloak from "vue-keycloak-js-19";
import VueRouter from "vue-router";
import Toast, { POSITION } from "vue-toastification";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

import Bootstrap from "./Bootstrap.vue";
import { initFilter } from "./plugins/filters";
import routes from "./router";
import store from "./store";

MomentUtils.setupFr();
const pinia = createPinia();

Vue.use(VueRouter);
initFilter();

// fix
// @ts-ignore
const router = new VueRouter({
	mode: "history",
	routes,
});

pinia.use(
	PiniaLogger({
		expanded: true,
		disabled: true,
	}),
);

Vue.use(Toast, {
	// Setting the global default position
	position: POSITION.BOTTOM_RIGHT,
	showCloseButtonOnHover: true,
	toastClassName: "hublot-toast",
});

Vue.config.productionTip = false;

Vue.use(PiniaVuePlugin);

setActivePinia(pinia);

moment.locale("fr");

const opts = {
	icons: { iconfont: "mdi" },
	theme: {
		options: { customProperties: true },
		themes: {
			light: {
				primary: "#376374",
				secondary: "#f35963",
			},
		},
	},
};

Vue.use(Vuetify, opts);

Vue.use(VueKeyCloak, {
	config: {
		clientId: "magasin-front",
		realm: "crm",
		url: "https://keycloak.hublot.io",
	},
	init: { onLoad: "login-required", checkLoginIframe: false },
	onReady: (kc) => {
		store.dispatch("login", kc).then(() => {
			new Vue({
				router,
				store,
				vuetify: new Vuetify(opts),
				el: "#app",
				head: {
					meta: [
						{
							name: "viewport",
							content: `width=device-width, initial-scale=1, 
              minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover`,
						},
					],
				},
				pinia,
				render: (h: any) => h(Bootstrap),
			});
		});
	},
});
